import { useEffect, useState } from "react";
import { Modal, Box, TextField, InputAdornment, Button } from "@mui/material";
import {
  getCustomers,
  getCustomersByZone,
} from "../../../services/customer-service";
import { getCompanies } from "../../../services/company-service";
import {
  getDefaultProducts,
  getProductByCompanyId,
} from "../../../services/product-service";
import SelectInput from "../../Select/SelectInput";
import getArrayNumbers from "../../../utils/generate-deadline-array";
import { modalStyle } from "../../../utils/modal-style";
import { getFreightCostByCompanyId } from "../../../services/freight-cost-service";
import {
  getCustoEntregaCliente,
  getIcmsArlaSameState,
  getK,
  getIcmsArlaDifferentState,
  correctHourAndMinutes,
  correctDate,
  getCustoFinanceiro,
} from "../../../utils/maths";
import { createSimulation } from "../../../services/simulations-service";
import { getIcmsStatesByCompanyId } from "../../../services/icms-service";
import { useNavigate } from "react-router-dom";

import "./CreateSimulationModal.scss";
import { getUserById } from "../../../services/user-service";

export default function CreateSimulationModal({ setOpen, open }) {
  const accessToken = localStorage.getItem("token");
  const role = Number(localStorage.getItem("role"));
  const userId = Number(localStorage.getItem("user"));
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [customers, setCustomers] = useState("");
  const [companies, setCompanies] = useState("");
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState("");
  const [products, setProducts] = useState([]);
  const [deadline, setDeadline] = useState("");
  const [price, setPrice] = useState("");
  const [volume, setVolume] = useState("");
  const [buyingPrice, setBuyingPrice] = useState("");
  const [selectValues, setSelectValues] = useState({
    clients: [],
    companies: [],
    cities: [],
    states: [
      { id: 9, name: "Goiás", uf: "GO" },
      { id: 11, name: "Minas Gerais", uf: "MG" },
      { id: 26, name: "São Paulo", uf: "SP" },
    ],
    products: [],
    deadlines: getArrayNumbers(),
  });

  const getDefaultSimulationDataLocal = JSON.parse(
    localStorage.getItem("simulacao")
  );

  async function handleSubmit(e) {
    e.preventDefault();

    const data = {
      client_id: customers,
      company_id: companies,
      city_id: cities,
      user_id: userId,
      uf_id: states,
      product_id: products,
      prazo: deadline,
      preco: Number(price),
      volume: Number(volume),
      status: "pendente",
      time_simulation: correctHourAndMinutes(),
      dt_simulation: correctDate(),
      k: 0,
      preco_compra: 0,
      cec: 0,
      c_financeiro: 0,
      icms: 0,
    };

    const selectedCompany = selectValues.companies.find(
      (company) => company.id === companies
    );
    const findCity = selectValues.cities.find(
      (city) => city.city_id === cities
    );
    const custo_financeiro = getCustoFinanceiro(deadline, price);

    // se o produto for arla
    if (products === 3) {
      if (selectedCompany.state_id === states) {
        // console.log("entrou no arla mesmo estado");
        const cec = getCustoEntregaCliente(
          companies,
          selectedCompany.custo_km,
          findCity.km_idv,
          selectedCompany.custo_partida
        );

        const getProductValue = buyingPrice.find((product) =>
          product.name.includes("arla granel")
        ).price;
        const icms = getIcmsArlaSameState(price, getProductValue);
        const k = getK(price, getProductValue, icms, cec, custo_financeiro);

        try {
          const teste = await createSimulation(accessToken, {
            ...data,
            k: Number(k),
            preco_compra: getProductValue,
            cec: Number(cec),
            c_financeiro: Number(custo_financeiro),
            icms: icms[0].price,
          });

          navigate(`/simulacoes/${teste.data}`);
          setOpen(false);
        } catch (error) {
          alert("Algo deu errado, tente novamente.");
        }
      }

      if (selectedCompany.state_id !== states) {
        // console.log(findCity);
        const cec = getCustoEntregaCliente(
          companies,
          selectedCompany.custo_km,
          findCity.km_idv,
          selectedCompany.custo_partida
        );

        const getProductValue = buyingPrice.find((product) =>
          product.name.includes("arla granel")
        ).price;

        // const getAllIcms = await getIcmsStatesByCompanyId(accessToken);
        // const getCorrectValue = getAllIcms.find(
        //   (icms) =>
        //     (icms.ufpartida_id === states &&
        //       icms.ufentrega_id === selectedCompany.state_id &&
        //       icms.produto_id === products) ||
        //     (icms.ufpartida_id === selectedCompany.state_id &&
        //       icms.ufentrega_id === states &&
        //       icms.produto_id === products)
        // );

        // console.log({
        //   getCorrectValue,
        //   states,
        //   products,
        //   companyProduct: selectedCompany.state_id,
        //   getAllIcms,
        // });
        const icms = getIcmsArlaDifferentState(price);
        const k = getK(price, getProductValue, icms, cec, custo_financeiro);

        try {
          const createSimu = await createSimulation(accessToken, {
            ...data,
            k: Number(k),
            preco_compra: getProductValue,
            cec: Number(cec),
            c_financeiro: Number(custo_financeiro),
            icms: icms[0].price,
          });

          setOpen(false);
          navigate(`/simulacoes/${createSimu.data}`);
        } catch (error) {
          alert("Algo deu errado, tente novamente.");
        }
      }
    }

    // s-10 adt
    if (products === 1) {
      // mesmo estado
      if (selectedCompany.state_id === states) {
        const cec = getCustoEntregaCliente(
          companies,
          selectedCompany.custo_km,
          findCity.km_idv,
          selectedCompany.custo_partida
        );
        // console.log("mesmo estado s10adt");
        const getProductValue = buyingPrice.find((product) =>
          product.name.includes("s-10 adt")
        ).price;

        const k = getK(price, getProductValue, 0, cec, custo_financeiro);

        try {
          const createSimu = await createSimulation(accessToken, {
            ...data,
            k: Number(k),
            preco_compra: getProductValue,
            cec: Number(cec),
            c_financeiro: Number(custo_financeiro),
          });

          setOpen(false);
          return navigate(`/simulacoes/${createSimu.data}`);
        } catch (error) {
          alert("Algo deu errado, tente novamente.");
        }
      }

      if (selectedCompany.state_id === 26) {
        // empresa estado de SP
        if (selectedCompany.state_id !== states) {
          // SP para MG
          if (
            (selectedCompany.state_id === 26 && states === 11) ||
            (selectedCompany.state_id === 11 && states === 26)
          ) {
            // console.log("diferente estado s10 adt");
            const icmsArray = await getIcmsStatesByCompanyId(accessToken);
            const icms = icmsArray.filter(
              (icms) => icms.produto_id === 1 && icms.ufpartida_id === 26
            );
            const cec = getCustoEntregaCliente(
              companies,
              selectedCompany.custo_km,
              findCity.km_idv,
              selectedCompany.custo_partida
            );

            const getProductValue = buyingPrice.find((product) =>
              product.name.includes("s-10 adt")
            ).price;

            const k = getK(
              price,
              getProductValue,
              icms[0].price,
              cec,
              custo_financeiro
            );

            try {
              const createSimu = await createSimulation(accessToken, {
                ...data,
                k: Number(k),
                preco_compra: getProductValue,
                cec: Number(cec),
                c_financeiro: Number(custo_financeiro),
                icms: icms[0].price,
              });

              setOpen(false);
              return navigate(`/simulacoes/${createSimu.data}`);
            } catch (error) {
              return alert("Algo deu errado, tente novamente.");
            }
          }
        }
      }

      // se for de MG para GO
      if (selectedCompany.state_id === 11) {
        if (
          (selectedCompany.state_id === 11 && states === 9) ||
          (selectedCompany.state_id === 9 && states === 11)
        ) {
          // console.log("MG para GO");
          const icmsArray = await getIcmsStatesByCompanyId(accessToken);
          const icms = icmsArray.filter(
            (icms) => icms.produto_id === 1 && icms.ufpartida_id === 11
          );

          const cec = getCustoEntregaCliente(
            companies,
            selectedCompany.custo_km,
            findCity.km_idv,
            selectedCompany.custo_partida
          );

          const getProductValue = buyingPrice.find((product) =>
            product.name.includes("s-10 adt")
          ).price;

          const k = getK(
            price,
            getProductValue,
            icms[0].price,
            cec,
            custo_financeiro
          );

          try {
            const createSimu = await createSimulation(accessToken, {
              ...data,
              k: Number(k),
              preco_compra: getProductValue,
              cec: Number(cec),
              c_financeiro: Number(custo_financeiro),
              icms: icms[0].price,
            });

            setOpen(false);
            return navigate(`/simulacoes/${createSimu.data}`);
          } catch (error) {
            alert("Algo deu errado, tente novamente.");
          }
        }
      }
      alert("Estado inválido ou cidade não atendida pela empresa.");
    }

    // s-500 adt
    if (products === 2) {
      if (selectedCompany.state_id === states) {
        const cec = getCustoEntregaCliente(
          companies,
          selectedCompany.custo_km,
          findCity.km_idv,
          selectedCompany.custo_partida
        );
        console.log("mesmo estado s500");
        const getProductValue = buyingPrice.find((product) =>
          product.name.includes("s-500 adt")
        ).price;
        // console.log(getProductValue);

        const k = getK(price, getProductValue, 0, cec, custo_financeiro);

        try {
          const createSimu = await createSimulation(accessToken, {
            ...data,
            k: Number(k),
            preco_compra: getProductValue,
            cec: Number(cec),
            c_financeiro: Number(custo_financeiro),
          });

          setOpen(false);
          return navigate(`/simulacoes/${createSimu.data}`);
        } catch (error) {
          alert("Algo deu errado, tente novamente.");
        }
      }

      if (selectedCompany.state_id !== states) {
        if (
          (selectedCompany.state_id === 26 && states === 11) ||
          (selectedCompany.state_id === 11 && states === 26)
        ) {
          // console.log("diferente estado s500 sp para mg");
          const icmsArray = await getIcmsStatesByCompanyId(accessToken);
          const icms = icmsArray.filter(
            (icms) => icms.produto_id === 2 && icms.ufpartida_id === 26
          );
          // console.log(icms);
          const cec = getCustoEntregaCliente(
            companies,
            selectedCompany.custo_km,
            findCity.km_idv,
            selectedCompany.custo_partida
          );

          const getProductValue = buyingPrice.find((product) =>
            product.name.includes("s-10 adt")
          ).price;
          console.log(icms[0].price);
          const k = getK(
            price,
            getProductValue,
            icms[0].price,
            cec,
            custo_financeiro
          );

          try {
            const createSimu = await createSimulation(accessToken, {
              ...data,
              k: Number(k),
              preco_compra: getProductValue,
              cec: Number(cec),
              c_financeiro: Number(custo_financeiro),
              icms: icms[0].price,
            });

            setOpen(false);
            return navigate(`/simulacoes/${createSimu.data}`);
          } catch (error) {
            alert("Algo deu errado, tente novamente.");
          }
        }
      }

      if (selectedCompany.state_id !== states) {
        if (
          (selectedCompany.state_id === 11 && states === 9) ||
          (selectedCompany.state_id === 9 && states === 11)
        ) {
          // console.log("diferente estado s500 mg para go");
          const icmsArray = await getIcmsStatesByCompanyId(accessToken);
          const icms = icmsArray.filter(
            (icms) => icms.produto_id === 2 && icms.ufpartida_id === 11
          );
          const cec = getCustoEntregaCliente(
            companies,
            selectedCompany.custo_km,
            findCity.km_idv,
            selectedCompany.custo_partida
          );

          const getProductValue = buyingPrice.find((product) =>
            product.name.includes("s-10 adt")
          ).price;

          const k = getK(
            price,
            getProductValue,
            icms[0].price,
            cec,
            custo_financeiro
          );

          try {
            const createSimu = await createSimulation(accessToken, {
              ...data,
              k: Number(k),
              preco_compra: getProductValue,
              cec: Number(cec),
              c_financeiro: Number(custo_financeiro),
              icms,
            });

            setOpen(false);
            return navigate(`/simulacoes/${createSimu.data}`);
          } catch (error) {
            alert("Algo deu errado, tente novamente.");
          }
        }
      }
    }
  }

  useEffect(() => {
    async function getData() {
      try {
        const userData = await getUserById(accessToken, userId);

        const userZones = userData?.zones.map((zone) => zone.id);

        let customers;

        if (role === 1) {
          const result = await getCustomers(accessToken);
          customers = result;
        }

        if (userData.zones) {
          const result = await getCustomersByZone(accessToken, userZones);
          customers = result;
        }

        const companies = await getCompanies(accessToken);
        const products = await getDefaultProducts(accessToken);

        const sortedCustomers = await customers.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );

        setSelectValues((prevState) => {
          return {
            ...prevState,
            customers: sortedCustomers,
            companies,
            products,
          };
        });

        setStates(getDefaultSimulationDataLocal?.uf_id);
        setCustomers(getDefaultSimulationDataLocal?.client_id);
        setCompanies(getDefaultSimulationDataLocal?.company_id);
        setCities(getDefaultSimulationDataLocal?.city_id);
        setDeadline(getDefaultSimulationDataLocal?.prazo);
        setVolume(getDefaultSimulationDataLocal?.volume);
        setProducts(getDefaultSimulationDataLocal?.product_id);
        setPrice(getDefaultSimulationDataLocal?.preco);
      } catch (error) {
        alert("Algo deu errado. Tente novamente mais tarde.");
      }
    }
    getData(accessToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function getProductByCompany() {
      console.log(companies);
      if (companies) {
        const products = await getProductByCompanyId(accessToken, companies);
        const cities = await getFreightCostByCompanyId(accessToken, companies);
        setBuyingPrice(products);
        setSelectValues((prevState) => {
          return {
            ...prevState,
            cities,
          };
        });
      }
    }

    getProductByCompany();
  }, [companies, accessToken]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-modal" sx={modalStyle}>
          <form onSubmit={handleSubmit} className="form-container-simulations">
            <h2>Simulador Unipetro</h2>

            <SelectInput
              value={customers}
              name="Clientes"
              setValue={setCustomers}
              selectValues={selectValues.customers}
            />

            <SelectInput
              value={companies}
              name="Selecionar a empresa"
              setValue={setCompanies}
              selectValues={selectValues.companies}
            />

            <SelectInput
              value={states}
              name="Estado"
              setValue={setStates}
              selectValues={selectValues.states}
            />

            <SelectInput
              value={cities}
              name="Cidades"
              city
              setValue={setCities}
              selectValues={selectValues.cities}
            />

            <SelectInput
              value={products}
              name="Produto"
              setValue={setProducts}
              selectValues={selectValues.products}
            />

            <TextField
              label="Volume"
              name="volume"
              type="number"
              value={volume}
              onChange={(e) => setVolume(e.target.value)}
            />

            <SelectInput
              value={deadline}
              name="Prazo"
              setValue={setDeadline}
              selectValues={selectValues.deadlines}
            />

            <TextField
              label="Preço"
              name="preço"
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              step={0.5}
              min={0}
              inputProps={{ step: "0.0001" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />

            <Button type="submit" variant="contained">
              Simular
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
}
